
export const ROLES = {
    Admin : 'admin',
    Realtor: 'realtor'
}
